// Modules
import { configureStore, getDefaultMiddleware } from '@reduxjs/toolkit';
import logger from 'redux-logger';

// Reducer
import {Store as rootReducer} from '../rootReducer';

// Constant
import Constant from '../../constants/contant';

const middleware = [...getDefaultMiddleware()];
// if (process.env.NODE_ENV === Constant.DEV) {
// 	middleware.push(logger);
// }

export default configureStore({
	reducer: rootReducer,
	middleware,
	devTools: process.env.NODE_ENV === Constant.DEV,
});
